<template>
  <div class="header-top-wrapper">
    <div class="logo-wrapper">
      <img class="bg" :src="source('logo-3')" draggable="false">
      <div class="logo-1" @click="gotoPage('/')"></div>

      <img v-if="showIcon" class="project-featured" :src="source('featured-button')" alt="" @click="back">
      <img class="menu-icon" :src="source('menu')" alt="" @click="showMenuHandle(true)"
           :style="showIcon ? '':'marginLeft: auto; margin-right: 4vw;'" v-show="isShowMenuIcon">
    </div>

    <transition name="fade">
      <div class="menu-mask-wrapper" v-show="showMenu">
        <img class="clear-icon" :src="source('close')" alt="" @click="showMenuHandle(false)">
        <div class="menu-item one" @click="gotoPage('/')">HOME</div>
        <div class="menu-item two" @click="gotoPage('/who-we-are')">WHO WE WORK</div>
        <div class="menu-item three" @click="gotoPage('/products')">PROJECTS</div>
        <div class="menu-item four" @click="gotoPage('/team')">OUR TEAM</div>
        <div class="menu-item five" @click="gotoPage('/contact')">CONTACT</div>
      </div>
    </transition>
  </div>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'header-top',
  props: {
    showIcon: {type: Boolean, default: false}
  },
  data() {
    return {
      isShowMenuIcon: true,
      showMenu: false
    }
  },
  methods: {
    showMenuHandle(flag) {
      this.isShowMenuIcon = !flag
      this.showMenu = flag
    },
    back() {
      this.$router.back()
    },
    gotoPage(path) {
      this.showMenu = false
      this.isShowMenuIcon = true
      this.$router.push({path}).catch(() => {
      })
    },
    source(name) {
      const res = key.getByName(key.COMMON, name)
      return res.fileUrl
    }
  }
}
</script>

<style scoped lang="scss">
.header-top-wrapper {
  .logo-wrapper {
    width: 100vw;
    height: 4.11vw;
    position: fixed;
    display: flex;
    align-items: center;
    z-index: 9999;

    .logo-1 {
      margin-left: 3.5vw;
      width: 15.80vw;
      height: 100%;

        &:hover {
          cursor: pointer;
        }
    }

    .project-featured {
      margin-left: auto;
      margin-right: 2.865vw;
      width: 22.552vw;
      height: 4.167vw;
      cursor: pointer;
    }

    .menu-icon {
      width: 2.75vw;
      height: 2.75vw;
      cursor: pointer;
    }
  }

  .menu-mask-wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    background-color: rgba(0, 0, 255, .85);
    z-index: 9999;

    .clear-icon {
      position: absolute;
      top: 2.396vw;
      right: 3.021vw;
      width: 3.75vw;
      height: 3.75vw;

      &:hover {
        cursor: pointer;
      }
    }

    .menu-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 5vw;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 4.479vw;

      &:hover {
        cursor: pointer;
        font-size: 5.521vw;
        transition: all .2s ease-out;
      }

      &.one {
        margin-top: 10vw;
      }

      &.two, &.three, &.four, &.five {
        margin-top: 2vw;
      }
    }
  }
}

.fade-enter-active {
  animation: fadeInDown .5s;
}

.fade-leave-active {
  animation: fadeInDown .5s reverse
}
</style>
